import { NameComponent } from './../../common/components/name/name.component';
import { Injectable, NgZone } from '@angular/core';
import { FormControlStatus, FormGroup, Validators } from '@angular/forms';
import { BaseFpxComponentState, BaseFpxFormHelper, BaseFpxPostSubmitInterceptor, CriteriaQuery, RoutingInfo } from "@fpx/core";
import {
  BaseFpxChangeHandler,
  BaseFpxEventHandler,
  BaseFpxLoadFormHandler,
  FindByKeyFn,
  HttpRequest,
} from '@common/models';
import { BillRequestService } from '../billRequest-service/billRequest.service';
import { BillRequest } from '../billRequest-service/billRequest.model';
import { ADDITIONAL_DETAILS } from '@common/constants';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';
import { CommonService } from 'src/app/common.service';
import moment from 'moment';
import { API_DATE_FORMAT } from '@fpx/common/constants';
import { Router } from '@angular/router';
import { BPBillRequestFormComponent } from './bp-billRequest-form.component';
import { MatDialogRef } from '@angular/material/dialog';




export class BPBillRequestFormState extends BaseFpxComponentState {
  showSuggestion: boolean = false;
  minDate: string;
  maxDate: string;
  isDateValid;
}


@Injectable()
export class BPBillRequestFormHelper extends BaseFpxFormHelper<BPBillRequestFormState>{

  constructor(public commonService: CommonService, private bPBillRequestFormService: BillRequestService,
    private _processShellService: ProcessShellService, private router: Router,
    private _matDialogRef: MatDialogRef<BPBillRequestFormComponent>,
  ) {
    super(new BPBillRequestFormState());
  }

  private fromDateChange: BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup) => {
    if (value) {
      if (status == 'VALID') {
        formGroup.get('fromDate').setErrors(null, { emitEvent: false });
        let fromDateValue = formGroup.get('fromDate').value;
        let toDateValue = formGroup.get('toDate').value;
        this.checkFromAndToRequired(formGroup);
        if (fromDateValue != '' && toDateValue != '' && moment(fromDateValue).isBefore(moment(toDateValue))
        ) {
          formGroup.get('toDate').setErrors({ fromDateGreaterError: true }, { emitEvent: false });
        } else {
          formGroup.get('toDate').setErrors(null, { emitEvent: false });
        }
      }

    } else if (value == '') {
    }
  }

  private toDateChange: BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup) => {
    if (value) {
      if (status == 'VALID') {
        formGroup.get('fromDate').setErrors(null, { emitEvent: false });
        let fromDateValue = formGroup.get('fromDate').value;
        let toDateValue = formGroup.get('toDate').value;
        this.checkFromAndToRequired(formGroup);
        if (fromDateValue != '' && toDateValue != '' && moment(fromDateValue).isAfter(moment(toDateValue))) {
          formGroup.get('fromDate').setErrors({ toDateGreaterError: true }, { emitEvent: false });
        } else {
          formGroup.get('fromDate').setErrors(null, { emitEvent: false });
        }
      }
    } else if (value == '') {
    }

  }

  checkFromAndToRequired(formGroup: FormGroup) {
    let fromDateValue = formGroup.get('fromDate').value;
    let toDateValue = formGroup.get('toDate').value;
    if ((fromDateValue != '' && toDateValue == '') || (fromDateValue == '' && toDateValue != '')) {
      this.state.isDateValid = true
    } else {
      this.state.isDateValid = false
    }

  }

  override doPreInit(): void {
    this._processShellService.setFooterVisible(false);
    this.addChangeHandler("fromDate", this.fromDateChange);
    this.addChangeHandler("toDate", this.toDateChange);
    this.state.maxDate = moment(new Date()).format(API_DATE_FORMAT);
    this.state.minDate = moment(new Date()).subtract(2, 'years').format(API_DATE_FORMAT);
  }

  public doDestroy(): void {
    this.bPBillRequestFormService.isBillHistoryAvailable = true;
  }


}
